// extracted by mini-css-extract-plugin
export var mediaAreaImg = "HeroMedia-module--mediaAreaImg--ua7YC";
export var playIcon = "HeroMedia-module--playIcon--wH94x";